<main class="co-content clearfix row" *ngIf="env === 'nkl'">
  <section class="co-content__left columns small-12 medium-8">
    <h1>NKL Lose auswählen</h1>
    <app-lottery-main></app-lottery-main>
    <footer class="co-content__footer clearfix row">
      <div class="columns medium-6">
        <p *ngIf="!showCartPage">
          Gutscheine können im letzten Bestellschritt “Bestellung überprüfen“
          eingelöst werden.
        </p>
      </div>
    </footer>
  </section>
  <aside class="co-content__right co-sidebar columns small-12 medium-4">
    <app-summary></app-summary>
  </aside>
</main>
<main class="co-content co-content--skl clearfix row" *ngIf="env === 'skl'">
  <h1>SKL Lose auswählen</h1>
  <app-lottery-skl></app-lottery-skl>
</main>
<app-summary-conf></app-summary-conf>
